import React from 'react';

export default class SubmitItemLoading extends React.PureComponent {
  render() {
    return (
      <div className="load-submit">
        <div className="modal-bg"></div>
        <div className="modal">
          <div className="modal-body">
            <div className="">
              <div
                className="first rest-breadcrumb white-bg d-flex justify-content-between align-items-center"
                style={{marginTop: '-56px', marginBottom: '10px', height: '50px'}}
              >
                <p
                  className="spinner-element animate"
                  style={{width: '43px', height: '16px'}}
                />
                <p
                  className="spinner-element animate"
                  style={{width: '88px', height: '16px'}}
                />
                <p
                  className="spinner-element animate"
                  style={{width: '43px', height: '16px'}}
                />
              </div>
              <div
                className="rest-breadcrumb white-bg"
                style={{padding: '13px 0 24px', marginBottom: '10px'}}
              >
                <p
                  className="spinner-element animate"
                  style={{width: '208px', height: '16px', margin: '0 auto 20px'}}
                />
                <div
                  className="d-flex align-items-center"
                  style={{
                    width: '150px',
                    height: '50px',
                    margin: '0 auto',
                    border: '1px solid #eff2f7',
                    borderRadius: '5px',
                  }}
                >
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{width: '50px', height: '50px'}}
                  >
                    <p
                      className="spinner-element animate"
                      style={{width: '20px', height: '16px'}}
                    />
                  </div>
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{width: '50px', height: '50px', background: '#e9ebee'}}
                  >
                    <p
                      className="spinner-element animate"
                      style={{width: '20px', height: '16px'}}
                    />
                  </div>
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{width: '50px', height: '50px'}}
                  >
                    <p
                      className="spinner-element animate"
                      style={{width: '20px', height: '16px'}}
                    />
                  </div>
                </div>
              </div>

              <div
                className="rest-breadcrumb white-bg"
                style={{marginBottom: '10px'}}
              >
                <p
                  className="spinner-element animate"
                  style={{width: '50px', height: '16px', marginBottom: '13px'}}
                />
                <div
                  className="d-flex justify-content-between align-items-center "
                  style={{
                    padding: '13px 16px 0 32px',
                    borderTop: '1px solid #eff2f7',
                  }}
                >
                  <p
                    className="spinner-element animate"
                    style={{width: '88px', height: '16px', marginBottom: '23px'}}
                  />
                  <p
                    className="spinner-element animate"
                    style={{width: '46px', height: '16px', marginBottom: '23px'}}
                  />
                </div>
                <div
                  className="d-flex justify-content-between align-items-center "
                  style={{padding: '0 16px 0 32px'}}
                >
                  <p
                    className="spinner-element animate"
                    style={{width: '88px', height: '16px', marginBottom: '23px'}}
                  />
                  <p
                    className="spinner-element animate"
                    style={{width: '46px', height: '16px', marginBottom: '23px'}}
                  />
                </div>
                <div
                  className="d-flex justify-content-between align-items-center "
                  style={{padding: '0 16px 0 32px'}}
                >
                  <p
                    className="spinner-element animate"
                    style={{width: '88px', height: '16px', marginBottom: '23px'}}
                  />
                  <p
                    className="spinner-element animate"
                    style={{width: '46px', height: '16px', marginBottom: '23px'}}
                  />
                </div>
              </div>

              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  background: '#eff2f7',
                  position: 'fixed',
                  width: '100%',
                  padding: '19px 0 15px',
                  left: '0',
                  bottom: '0',
                }}
              >
                <p
                  className="spinner-element animate"
                  style={{width: '208px', height: '16px'}}
                />
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}
